import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import * as icons from "../../../assets/exportSkills";

const DescriptionTechnologies = ({ technologies, previous, next }) => {
  console.log("icons123 :>> ", icons);

  console.log("technologies :>> ", technologies);
  console.log("icons :>> ", icons); //styledcomponentsImg
  const { t } = useTranslation();
  return (
    <div className="description-technologies">
      <div className="project-desc">{t("projectDescription.technologies")}</div>
      <StyledContainerImage>
        {technologies?.split(",").map((technology) => (
          <div>
            <SwitchImage>
              <section>
                <img
                  src={icons?.[technology?.toLowerCase()]}
                  alt={technology?.toLowerCase() + "Img"}
                />
                <div>{technology}</div>
              </section>
            </SwitchImage>
          </div>
        ))}
      </StyledContainerImage>

      <div className="link">
        <Link target="_blank" to={`/project/${previous}`}>
          {t("projectDescription.previous")}
        </Link>
        <Link target="_blank" to={`/project/${next}`}>
          {t("projectDescription.next")}
        </Link>
      </div>
    </div>
  );
};

export default DescriptionTechnologies;

const StyledContainerImage = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);

  section {
    width: 100%;
    margin-top: 20px;
  }
  @media (min-width: 700px) {
    grid-template-columns: repeat(4, 1fr);
    section {
      margin-top: 30px;
    }
  }
`;

const SwitchImage = styled.div`
  i {
    font-size: 40px;
    width: 40px;
    height: 40px;
  }
  img {
    font-size: 40px;
    width: 40px;
    height: 40px;
  }
  @media (min-width: 1100px) {
    i {
      font-size: 50px;
      width: 50px;
      height: 50px;
      margin-bottom: 10px;
    }
    img {
      font-size: 50px;
      width: 50px;
      height: 50px;
      margin-bottom: 10px;
    }
  }
`;
